module.exports = __webpack_public_path__ + "img/1.17a873d0.png";